<span #scrollHereOnFocus>
  <ion-item [lines]="props['itemLines']">
    @if (props.label) {
      <ts-ion-form-field-label-ui [props]="props"></ts-ion-form-field-label-ui>
    }
    <ng-template #fieldComponent></ng-template>
  </ion-item>
  <ts-ion-form-field-validation-message-ui
    [field]="field"
    [showError]="showError"
  ></ts-ion-form-field-validation-message-ui>
  <ts-ion-form-field-help-ui [props]="props"></ts-ion-form-field-help-ui>
</span>
